import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';

function PopBrochureList(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['수학 탄탄 교재', '수학 탄탄 교재', '수학 탄탄 교재', '단단히 쌓은 단어장(2013)', '단단히 쌓은 단어장(2013)', '단단히 쌓은 단어장(2013)', '단단히 쌓은 단어장(2013)'];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input pop_brochrelist" popSize="s">
      <h2 className="pop_tit">홍보책자 목록 관리</h2>
      <div className="content_container scroll">
        <div className="com_input_wrap">
          <select name="" id="" className="select">
            <option value="과목 선택">과목 선택</option>
          </select>
          <section className="search search_top">
            <input type="search" placeholder="직원명 검색" className="input wl type_search" />
            <button className="com_btn gray ws s icon_search"></button>
          </section>
          <ul className="com_scroll_list pick">
            {listItems.map((item, index) => (
              <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => handleClick(index)}>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="btn_wrap">
          <button className="com_btn orange s">+ 새 책자등록</button>
        </div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="28%" />
            <col width="60%" />
          </colgroup>
          <tbody>
            <tr>
              <th>영역</th>
              <td>
                <select name="" id="" className="select">
                  <option value="영역 선택">영역 선택</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>책자 구분</th>
              <td className="td_left">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                  <label htmlFor="rdo_01">인쇄책자</label>
                  <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                  <label htmlFor="rdo_02">디지털 책자</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>홍보 책자명</th>
              <td>
                <input type="text" className="input" defaultValue={`입력`} />
              </td>
            </tr>
            <tr>
              <th>파일등록</th>
              <td>
                <div className="com_input_upload">
                  <Upload title="파일 등록" className="com_btn gray s wl" />
                </div>
                <ul className="file_list">
                  <li>
                    <div className="com_input_upload">
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="com_input_upload">
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="btn_del_wrap">
          <button className="btn_delete"></button>
        </div>
        <hr className="com_divider" />
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopBrochureList;
